<template>
  <mdbContainer fluid>
    <mdbRow class="align-items-center">
      <mdbCol>
        <mdbInput v-model="phoneNumber" :label="$t('find_member_phonenumer_for_used_benefits_input_label')"
          :small="$t('find_member_phonenumer_for_used_benefits_input_small')" type="text" />
      </mdbCol>
      <mdbCol>
        <mdbBtn color="indigo" @click="findPhoneNumber">{{
          $t("find_member_phonenumber_for_usedbenefits_button")
          }}</mdbBtn>
      </mdbCol>
    </mdbRow>
    <mdbRow v-if="customerId !== null">
      <mdbCol col="12">
        <ag-grid-vue :style="'width:' + width + ';' + 'height:' + height + ';'" class="ag-theme-alpine"
          :pagination="true" :columnDefs="usedbenefits.columns" :rowData="usedbenefits.rows" @grid-ready="onGridReady"
          :rowHeight="100" />
      </mdbCol>
    </mdbRow>
    <mdbRow v-if="customerId !== null">
      <mdbCol col="12">
        <mdbBtn color="red" @click="deleteConfirmed(customerId)">{{ $t("delete_member_used_benefits") }}</mdbBtn>
      </mdbCol>
    </mdbRow>
  </mdbContainer>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { mdbContainer, mdbRow, mdbCol, mdbBtn, mdbInput } from "mdbvue";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ManageMemberUsedBenefits",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbInput,
    AgGridVue,
  },
  data() {
    return {
      deleteusedbenefitspath: "/1.0/front/benefitused/",
      fetchusedbenefitsbyphonenumberpath: "/1.0/front/benefitused/",
      dataLoadReady: false,
      gridApi: null,
      gridColumnApi: null,
      customerId: null,
      width: "1000px",
      height: "500px",
      usedbenefits: {
        columns: [
          {
            headerName: "Edun otsikko",
            field: "title",
            width: 500,
            resizable: true,
          },
          {
            headerName: "Edun teksti",
            field: "text",
            width: 500,
            resizable: true,
          },
        ],
        rows: null,
      },
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    findPhoneNumber() {
      this.$http
        .get(this.fetchusedbenefitsbyphonenumberpath + this.phoneNumber)
        .then((response) => {
          if (response.status == 200) {
            this.usedBenefitsLoaded(response.data);
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("find_member_phonenumber_for_usedbenefits_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          window.__logAxiosErrorIfDebug(error, {
            context: "ManageMemberUsedBenefits.vue - findPhoneNumber",
          });
        });
    },
    usedBenefitsLoaded(data) {
      this.usedbenefits.rows = data.benefitsused;
      this.customerId = data.customerid;
    },
    deleteConfirmed(id) {
      if (confirm("Haluatko varmasti poistaa käytetyt edut asiakkaalta?")) {
        this.postdata = JSON.stringify({
          customerid: id,
        });
        this.$http
          .delete(this.deleteusedbenefitspath + this.customerId)
          .then((response) => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("delete_member_used_benefits_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort,
              });
              this.$router.go();
            }
          })
          .catch((error) => {
            this.$notify.error({
              message: this.$t("delete_member_used_benefits_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
            console.log(error);
          });
      }
    },
  },
};
</script>